import React from 'react'

const Jva_ll = () => {
    return (
        <div className='container'>
            
      
      <h1 class="h1">Java LinkedList class</h1>
     
      <p>Java LinkedList class uses a doubly linked list to store the elements. It provides a linked-list data
            structure. It inherits the AbstractList class and implements List and Deque interfaces.</p>
      <p>The important points about Java LinkedList are:</p>
      <ul class="points">
            <li>Java LinkedList class can contain duplicate elements.</li>
            <li>Java LinkedList class maintains insertion order.</li>
            <li>Java LinkedList class is non synchronized.</li>
            <li>In Java LinkedList class, manipulation is fast because no shifting needs to occur.</li>
            <li>Java LinkedList class can be used as a list, stack or queue.</li>
      </ul>
     
      <h3 class="h3">Doubly Linked List</h3>
      <p>In the case of a doubly linked list, we can add or remove elements from both sides.</p>
     
      <h3 class="h3">LinkedList class declaration</h3>
      <p>Let's see the declaration for java.util.LinkedList class.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span> <span
                                          class="keywords">class</span><span>&nbsp;LinkedList&lt;E&gt;&nbsp;</span><br /><span
                                          class="keywords">extends</span><span>&nbsp;AbstractSequentialList&lt;E&gt;&nbsp;</span><br /><span
                                          class="keywords">implements</span><span>&nbsp;List&lt;E&gt;,&nbsp;Deque&lt;E&gt;,&nbsp;Cloneable,&nbsp;Serializable&nbsp;&nbsp;</span></span>
                        </li>
                  </ul>
                  
            </div>
      </div>
      <h3 class="h3">Constructors of Java LinkedList</h3>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>Constructor</th>
                        <th>Description</th>
                  </tr>
                  <tr>
                        <td>LinkedList()</td>
                        <td>It is used to construct an empty list.</td>
                  </tr>
                  <tr>
                        <td>LinkedList(Collection&lt;? extends E&gt; c)</td>
                        <td>It is used to construct a list containing the elements of the specified collection, in the
                              order, they are returned by the collection's iterator.</td>
                  </tr>
            </tbody>
      </table>
      <hr/>
      <h3 class="h3">Methods of Java LinkedList</h3>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>Method</th>
                        <th>Description</th>
                  </tr>
                  <tr>
                        <td>boolean add(E e)</td>
                        <td>It is used to append the specified element to the end of a list.</td>
                  </tr>
                  <tr>
                        <td>void add(int index, E element)</td>
                        <td>It is used to insert the specified element at the specified position index in a list.</td>
                  </tr>
                  <tr>
                        <td>boolean addAll(Collection&lt;? extends E&gt; c)</td>
                        <td>It is used to append all of the elements in the specified collection to the end of this
                              list, in the order that they are returned by the specified collection's iterator.</td>
                  </tr>
                  <tr>
                        <td>boolean addAll(Collection&lt;? extends E&gt; c)</td>
                        <td>It is used to append all of the elements in the specified collection to the end of this
                              list, in the order that they are returned by the specified collection's iterator.</td>
                  </tr>
                  <tr>
                        <td>boolean addAll(int index, Collection&lt;? extends E&gt; c)</td>
                        <td>It is used to append all the elements in the specified collection, starting at the specified
                              position of the list.</td>
                  </tr>

                  <tr>
                        <td>void addFirst(E e)</td>
                        <td>It is used to insert the given element at the beginning of a list.</td>
                  </tr>
                  <tr>
                        <td>void addLast(E e)</td>
                        <td>It is used to append the given element to the end of a list.</td>
                  </tr>
                  <tr>
                        <td>void clear()</td>
                        <td>It is used to remove all the elements from a list.</td>
                  </tr>
                  <tr>
                        <td>Object clone()</td>
                        <td>It is used to return a shallow copy of an ArrayList.</td>
                  </tr>
                  <tr>
                        <td>boolean contains(Object o)</td>
                        <td>It is used to return true if a list contains a specified element.</td>
                  </tr>
                  <tr>
                        <td>Iterator&lt;E&gt; descendingIterator()</td>
                        <td>It is used to return an iterator over the elements in a deque in reverse sequential order.
                        </td>
                  </tr>
                  <tr>
                        <td>E element()</td>
                        <td>It is used to retrieve the first element of a list.</td>
                  </tr>
                  <tr>
                        <td>E get(int index)</td>
                        <td>It is used to return the element at the specified position in a list.</td>
                  </tr>
                  <tr>
                        <td>E getFirst()</td>
                        <td>It is used to return the first element in a list.</td>
                  </tr>
                  <tr>
                        <td>E getLast()</td>
                        <td>It is used to return the last element in a list.</td>
                  </tr>

                  <tr>
                        <td>int indexOf(Object o)</td>
                        <td>It is used to return the index in a list of the first occurrence of the specified element,
                              or -1 if the list does not contain any element.</td>
                  </tr>
                  <tr>
                        <td>int lastIndexOf(Object o)</td>
                        <td>It is used to return the index in a list of the last occurrence of the specified element, or
                              -1 if the list does not contain any element.</td>
                  </tr>

                  <tr>
                        <td>ListIterator&lt;E&gt; listIterator(int index)</td>
                        <td>It is used to return a list-iterator of the elements in proper sequence, starting at the
                              specified position in the list.</td>
                  </tr>
                  <tr>
                        <td>boolean offer(E e)</td>
                        <td>It adds the specified element as the last element of a list.</td>
                  </tr>
                  <tr>
                        <td>boolean offerFirst(E e)</td>
                        <td>It inserts the specified element at the front of a list.</td>
                  </tr>
                  <tr>
                        <td>boolean offerLast(E e)</td>
                        <td>It inserts the specified element at the end of a list.</td>
                  </tr>
                  <tr>
                        <td>E peek()</td>
                        <td>It retrieves the first element of a list</td>
                  </tr>
                  <tr>
                        <td>E peekFirst()</td>
                        <td>It retrieves the first element of a list or returns null if a list is empty.</td>
                  </tr>
                  <tr>
                        <td>E peekLast()</td>
                        <td>It retrieves the last element of a list or returns null if a list is empty.</td>
                  </tr>
                  <tr>
                        <td>E poll()</td>
                        <td>It retrieves and removes the first element of a list.</td>
                  </tr>
                  <tr>
                        <td>E pollFirst()</td>
                        <td>It retrieves and removes the first element of a list, or returns null if a list is empty.
                        </td>
                  </tr>
                  <tr>
                        <td>E pollLast()</td>
                        <td>It retrieves and removes the last element of a list, or returns null if a list is empty.
                        </td>
                  </tr>
                  <tr>
                        <td>E pop()</td>
                        <td>It pops an element from the stack represented by a list.</td>
                  </tr>
                  <tr>
                        <td>void push(E e)</td>
                        <td>It pushes an element onto the stack represented by a list.</td>
                  </tr>
                  <tr>
                        <td>E remove()</td>
                        <td>It is used to retrieve and removes the first element of a list.</td>
                  </tr>
                  <tr>
                        <td>E remove(int index)</td>
                        <td>It is used to remove the element at the specified position in a list.</td>
                  </tr>
                  <tr>
                        <td>boolean remove(Object o)</td>
                        <td>It is used to remove the first occurrence of the specified element in a list.</td>
                  </tr>
                  <tr>
                        <td>E removeFirst()</td>
                        <td>It removes and returns the first element from a list.</td>
                  </tr>
                  <tr>
                        <td>boolean removeFirstOccurrence(Object o)</td>
                        <td>It is used to remove the first occurrence of the specified element in a list (when
                              traversing the list from head to tail).</td>
                  </tr>
                  <tr>
                        <td>E removeLast()</td>
                        <td>It removes and returns the last element from a list.</td>
                  </tr>
                  <tr>
                        <td>boolean removeLastOccurrence(Object o)</td>
                        <td>It removes the last occurrence of the specified element in a list (when traversing the list
                              from head to tail).</td>
                  </tr>
                  <tr>
                        <td>E set(int index, E element)</td>
                        <td>It replaces the element at the specified position in a list with the specified element.</td>
                  </tr>
                  <tr>
                        <td>Object[] toArray()</td>
                        <td>It is used to return an array containing all the elements in a list in proper sequence (from
                              first to the last element).</td>
                  </tr>
                  <tr>
                        <td>&lt;T&gt; T[] toArray(T[] a)</td>
                        <td>It returns an array containing all the elements in the proper sequence (from first to the
                              last element); the runtime type of the returned array is that of the specified array.</td>
                  </tr>

                  <tr>
                        <td>int size()</td>
                        <td>It is used to return the number of elements in a list.</td>
                  </tr>





            </tbody>
      </table>
      <hr/>
     

      <h3 class="h3">Java LinkedList Example</h3>

      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;LinkedList1&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;LinkedList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;</span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;Iterator&lt;String&gt;&nbsp;itr=al.iterator();&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">while</span><span>(itr.hasNext())&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;System.out.println(itr.next());&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>


      <div class="output">
            <pre>Output: Ravi <br/>
             Vijay <br/>
             Ravi <br/>
             Ajay <br/>
      </pre>
      </div>
      <hr/>
      <h3 class="h3">Java LinkedList example to add elements</h3>
      <p>Here, we see different ways to add elements.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;LinkedList2&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;LinkedList&lt;String&gt;&nbsp;ll=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Initial&nbsp;list&nbsp;of&nbsp;elements:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;add(E&nbsp;e)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;an&nbsp;element&nbsp;at&nbsp;the&nbsp;specific&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="number">1</span><span>,&nbsp;</span><span
                                          class="string">"Gaurav"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;add(int&nbsp;index,&nbsp;E&nbsp;element)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LinkedList&lt;String&gt;&nbsp;ll2=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll2.add(<span
                                          class="string">"Sonoo"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll2.add(<span
                                          class="string">"Hanumat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;second&nbsp;list&nbsp;elements&nbsp;to&nbsp;the&nbsp;first&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.addAll(ll2);&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;addAll(Collection&lt;?&nbsp;extends&nbsp;E&gt;&nbsp;c)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LinkedList&lt;String&gt;&nbsp;ll3=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll3.add(<span
                                          class="string">"John"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll3.add(<span
                                          class="string">"Rahul"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;second&nbsp;list&nbsp;elements&nbsp;to&nbsp;the&nbsp;first&nbsp;list&nbsp;at&nbsp;specific&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.addAll(<span
                                          class="number">1</span><span>,&nbsp;ll3);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;addAll(int&nbsp;index,&nbsp;Collection&lt;?&nbsp;extends&nbsp;E&gt;&nbsp;c)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;an&nbsp;element&nbsp;at&nbsp;the&nbsp;first&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.addFirst(<span
                                          class="string">"Lokesh"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;addFirst(E&nbsp;e)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;an&nbsp;element&nbsp;at&nbsp;the&nbsp;last&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.addLast(<span
                                          class="string">"Harsh"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;addLast(E&nbsp;e)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>

      <div class="output">
            <pre>Initial list of elements: [] <br />
      After invoking add(E e) method: [Ravi, Vijay, Ajay] <br />
      After invoking add(int index, E element) method: [Ravi, Gaurav, Vijay, Ajay] <br />
      After invoking addAll(Collection&lt;? extends E&gt; c) method:  <br />
      [Ravi, Gaurav, Vijay, Ajay, Sonoo, Hanumat] <br />
      After invoking addAll(int index, Collection&lt;? extends E&gt; c) method:  <br />
      [Ravi, John, Rahul, Gaurav, Vijay, Ajay, Sonoo, Hanumat] <br />
      After invoking addFirst(E e) method:  <br />
      [Lokesh, Ravi, John, Rahul, Gaurav, Vijay, Ajay, Sonoo, Hanumat] <br />
      After invoking addLast(E e) method:  <br />
      [Lokesh, Ravi, John, Rahul, Gaurav, Vijay, Ajay, Sonoo, Hanumat, Harsh] <br />
      </pre> <br />
      </div>

      <hr/>

      <h3 class="h3">Java LinkedList example to remove elements</h3>
      <p>Here, we see different ways to remove an element.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;LinkedList3&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;[]&nbsp;args)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LinkedList&lt;String&gt;&nbsp;ll=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Anuj"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Gaurav"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Harsh"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Virat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Gaurav"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Harsh"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Amit"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Initial&nbsp;list&nbsp;of&nbsp;elements:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;specific&nbsp;element&nbsp;from&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.remove(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;remove(object)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;element&nbsp;on&nbsp;the&nbsp;basis&nbsp;of&nbsp;specific&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.remove(<span
                                          class="number">0</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;remove(index)&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LinkedList&lt;String&gt;&nbsp;ll2=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll2.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll2.add(<span
                                          class="string">"Hanumat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//&nbsp;Adding&nbsp;new&nbsp;elements&nbsp;to&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.addAll(ll2);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Updated&nbsp;list&nbsp;:&nbsp;"</span><span>+ll);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;all&nbsp;the&nbsp;new&nbsp;elements&nbsp;from&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.removeAll(ll2);&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeAll()&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;first&nbsp;element&nbsp;from&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.removeFirst();&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeFirst()&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;first&nbsp;element&nbsp;from&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.removeLast();&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeLast()&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;first&nbsp;occurrence&nbsp;of&nbsp;element&nbsp;from&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.removeFirstOccurrence(<span
                                          class="string">"Gaurav"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeFirstOccurrence()&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;last&nbsp;occurrence&nbsp;of&nbsp;element&nbsp;from&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.removeLastOccurrence(<span
                                          class="string">"Harsh"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeLastOccurrence()&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;all&nbsp;the&nbsp;elements&nbsp;available&nbsp;in&nbsp;the&nbsp;list&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.clear();&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;clear()&nbsp;method:&nbsp;"</span><span>+ll);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                  </ul>
            </div>
      </div>
      <div class="output">
            <pre>Initial list of elements: [Ravi, Vijay, Ajay, Anuj, Gaurav, Harsh, Virat, Gaurav, Harsh, Amit] <br />
      After invoking remove(object) method: [Ravi, Ajay, Anuj, Gaurav, Harsh, Virat, Gaurav, Harsh, Amit] <br />
      After invoking remove(index) method: [Ajay, Anuj, Gaurav, Harsh, Virat, Gaurav, Harsh, Amit] <br />
      Updated list : [Ajay, Anuj, Gaurav, Harsh, Virat, Gaurav, Harsh, Amit, Ravi, Hanumat] <br />
      After invoking removeAll() method: [Ajay, Anuj, Gaurav, Harsh, Virat, Gaurav, Harsh, Amit] <br />
      After invoking removeFirst() method: [Gaurav, Harsh, Virat, Gaurav, Harsh, Amit] <br />
      After invoking removeLast() method: [Gaurav, Harsh, Virat, Gaurav, Harsh] <br />
      After invoking removeFirstOccurrence() method: [Harsh, Virat, Gaurav, Harsh] <br />
      After invoking removeLastOccurrence() method: [Harsh, Virat, Gaurav] <br />
      After invoking clear() method: [] <br />
      </pre> <br />
      </div>
      <hr/>

      <h3 class="h3">Java LinkedList Example to reverse a list of elements</h3>

      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;LinkedList4&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;LinkedList&lt;String&gt;&nbsp;ll=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ll.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;the&nbsp;list&nbsp;of&nbsp;elements&nbsp;in&nbsp;reverse&nbsp;order</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Iterator&nbsp;i=ll.descendingIterator();&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">while</span><span>(i.hasNext())&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(i.next());&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>


      <div class="output">
            <pre>Output: Ajay <br />
      Vijay <br />
      Ravi <br />
      
      </pre>
      </div>
      <hr/>

      <h3 class="h3">Java LinkedList Example: Book</h3>
      <div class="containers">
            <div class="dp-highlighter">
                 
                      
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keywords">class</span><span>&nbsp;Book&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span class="keywords">int</span><span>&nbsp;id;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>String&nbsp;name,author,publisher;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span><span
                                          class="keywords">int</span><span>&nbsp;quantity;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;Book(</span><span
                                          class="keywords">int</span><span>&nbsp;id,&nbsp;String&nbsp;name,&nbsp;String&nbsp;author,&nbsp;String&nbsp;publisher,&nbsp;</span><span
                                          class="keywords">int</span><span>&nbsp;quantity)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.id&nbsp;=&nbsp;id;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.name&nbsp;=&nbsp;name;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.author&nbsp;=&nbsp;author;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.publisher&nbsp;=&nbsp;publisher;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.quantity&nbsp;=&nbsp;quantity;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;LinkedListExample&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;list&nbsp;of&nbsp;Books</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;List&lt;Book&gt;&nbsp;list=<span
                                          class="keywords">new</span><span>&nbsp;LinkedList&lt;Book&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;Books</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b1=<span
                                          class="keywords">new</span><span>&nbsp;Book(</span><span
                                          class="number">101</span><span>,</span><span
                                          class="string">"Let&nbsp;us&nbsp;C"</span><span>,</span><span
                                          class="string">"Yashwant&nbsp;Kanetkar"</span><span>,</span><span
                                          class="string">"BPB"</span><span>,</span><span
                                          class="number">8</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b2=<span
                                          class="keywords">new</span><span>&nbsp;Book(</span><span
                                          class="number">102</span><span>,</span><span
                                          class="string">"Data&nbsp;Communications&nbsp;&amp;&nbsp;Networking"</span><span>,</span><span
                                          class="string">"Forouzan"</span><span>,</span><span
                                          class="string">"Mc&nbsp;Graw&nbsp;Hill"</span><span>,</span><span
                                          class="number">4</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b3=<span
                                          class="keywords">new</span><span>&nbsp;Book(</span><span
                                          class="number">103</span><span>,</span><span
                                          class="string">"Operating&nbsp;System"</span><span>,</span><span
                                          class="string">"Galvin"</span><span>,</span><span
                                          class="string">"Wiley"</span><span>,</span><span
                                          class="number">6</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;Books&nbsp;to&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;list.add(b1);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;list.add(b2);&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;list.add(b3);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(Book&nbsp;b:list)&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(b.id+<span
                                          class="string">"&nbsp;"</span><span>+b.name+</span><span
                                          class="string">"&nbsp;"</span><span>+b.author+</span><span
                                          class="string">"&nbsp;"</span><span>+b.publisher+</span><span
                                          class="string">"&nbsp;"</span><span>+b.quantity);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>
      <p>Output:</p>
      <div class="output">
            <pre>101 Let us C Yashwant Kanetkar BPB 8 <br />
      102 Data Communications &amp; Networking Forouzan Mc Graw Hill 4 <br />
      103 Operating System Galvin Wiley 6 <br />
      </pre>
      </div> 


        </div>
    )
}

export default Jva_ll
